import { render, staticRenderFns } from "./PreceptorForm.vue?vue&type=template&id=cd98d384&scoped=true"
import script from "./PreceptorForm.vue?vue&type=script&lang=js"
export * from "./PreceptorForm.vue?vue&type=script&lang=js"
import style0 from "./PreceptorForm.vue?vue&type=style&index=0&id=cd98d384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd98d384",
  null
  
)

export default component.exports